import {
  Dialog,
  Grid,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
  CircularProgress,
} from '@mui/material';
import { postApiCall } from 'api/apiService';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { AGENT_WITHDRAW_PRIVATE_OFFER } from 'constant/app.config';
import Swal from 'sweetalert2';
import { useState, useEffect } from 'react';
import Loading from 'assets/images/loading.png';

const WithdrawOfferDialog = ({
  openWithdraw,
  setOpenWithdraw,
  withdrawLeftCount = 1,
  tableData,
  onClose,
  buyer,
  open,
  buyerHistory,
  vendorHistoryData,
  vendor,
  privateoffer,
  getListInfo,
  getcall,
  offerPrice,
}) => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  // const isXsScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const [loading, setLoading] = useState(false);

  // const handleWithdrawPrivateOffer = async () => {
  //   const propertyId = tableData?.PropertyDetails?.property?.propertyId;
  //   const vendorId = vendor?.vendorId;
  //   const offerPrice = vendor?.offerPrice;

  //   if (!propertyId || !vendorId) return;

  //   const payload = {
  //     propertyId,
  //     vendorId,
  //     offerPrice,
  //   };

  //   try {
  //     setLoading(true);

  //     const response = await postApiCall(AGENT_WITHDRAW_PRIVATE_OFFER, payload);

  //     // Group call AFTER API is done
  //     getcall();

  //     onClose();

  //     Swal.fire({
  //       title: response?.data?.heading,
  //       text: response?.data?.message,
  //       icon: 'success',
  //       confirmButtonText: 'Close',
  //     });
  //   } catch (error) {
  //     // Swal.fire({
  //     //   title: response?.data?.heading ,
  //     //   text: response?.data?.message,
  //     //   icon: "error",
  //     //   confirmButtonText: "Close",
  //     // });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleWithdrawPrivateOffer = async () => {
    const propertyId = tableData?.PropertyDetails?.property?.propertyId;
    const vendorId = vendor?.vendorId;
    const offerPrice = vendor?.offerPrice;

    if (!propertyId || !vendorId) return;

    const payload = {
      propertyId,
      vendorId,
      offerPrice,
    };

    try {
      setLoading(true);

      const response = await postApiCall(AGENT_WITHDRAW_PRIVATE_OFFER, payload);

      if (response?.data?.status == 1) {
        // ✅ Success case
        getcall();

        // 🔹 Close dialog AFTER Swal closes (prevents double-click issue)
        Swal.fire({
          title: response?.data?.heading,
          text: response?.data?.message,
          icon: 'success',
          confirmButtonText: 'Close',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          onClose(); // Close only after Swal is dismissed
        });
      } else {
        console.error('API Error:', response?.data?.message);
        // setError(true); // ✅ Not needed

        Swal.fire({
          title: 'Error',
          text:
            response?.data?.message ||
            'Something went wrong. Please try again.',
          icon: 'error',
          confirmButtonText: 'Close',
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(() => {
          onClose(); // ✅ Closes after popup is dismissed
        });
      }
    } catch (error) {
      console.error('Withdraw offer failed:', error);
      // setError(true);

      Swal.fire({
        title: 'Error',
        text:
          error?.response?.data?.message ||
          error?.message ||
          'An unexpected error occurred. Please try again later.',
        icon: 'error',
        confirmButtonText: 'Close',
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '95%' : '400px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '30px 20px' : '20px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
              fontFamily: 'Poppins',
            }}
          >
            {tableData?.PropertyDetails?.propertyAddress?.streetName}
          </Typography>
        </Grid>

        <Grid item xs={12} display="flex" alignItems="center" py={2}>
          <Pendingwarning />
          <Typography
            sx={{
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
              fontFamily: 'Poppins',
              fontWeight: 500,
            }}
          >
            Withdraw Private Offer
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
              fontFamily: 'Poppins',
              marginTop: '50px',
            }}
          >
            You are withdrawing private offer of{' '}
            <b style={{ fontWeight: 550 }}> {vendor?.formattedPrice}</b>. <br />
            This private offer will no longer be available for consideration.
            <br />
            <br />
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent="flex-end"
          gap={2}
          mt={matchessm ? '15px' : 5}
        >
          <Grid item>
            <Button
              variant="outlined"
              onClick={onClose}
              sx={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: 400,
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
            >
              {withdrawLeftCount < 1 ? 'Close' : 'Cancel'}
            </Button>
          </Grid>

          {withdrawLeftCount > 0 && (
            <Grid item>
              <Grid
                container
                alignItems="center"
                gap={1}
                sx={{ minWidth: '140px' }} // reserve space
              >
                <Button
                  variant="outlined"
                  disabled={loading}
                  onClick={handleWithdrawPrivateOffer}
                  sx={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#FFFFFF',
                    backgroundColor: '#4CA4D6',
                    fontWeight: 400,
                    fontFamily: 'Poppins',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                    border: 'none',
                    '&:hover': {
                      backgroundColor: '#4CA4D6',
                    },
                    // '&.Mui-disabled': {
                    //   opacity: 0.6,
                    //   backgroundColor: "#4CA4D6",
                    //   color: "#FFFFFF",
                    // },
                  }}
                >
                  Confirm
                </Button>

                {/* reserve space always */}
                <div style={{ width: '40px', height: '40px' }}>
                  {loading && (
                    <img
                      src={Loading}
                      alt="loader"
                      style={{ height: '40px', width: '40px' }}
                    />
                  )}
                </div>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default WithdrawOfferDialog;
